import * as React from "react";

type Props = {
  headerHideThreshold?: number;
};

function useStickyHeader({ headerHideThreshold = 400 }: Props = {}) {
  const [isHeaderVisible, setIsHeaderVisible] = React.useState(true);

  React.useEffect(() => {
    let previousScrollValue: number;

    function handleScroll() {
      const currentScroll = window.scrollY;

      if (typeof previousScrollValue !== "number") {
        previousScrollValue = currentScroll;
        return;
      }

      const direction: "up" | "down" =
        currentScroll > previousScrollValue ? "down" : "up";

      if (
        isHeaderVisible &&
        direction === "down" &&
        currentScroll > headerHideThreshold
      ) {
        setIsHeaderVisible(false);
      } else if (!isHeaderVisible && direction === "up") {
        setIsHeaderVisible(true);
      }

      previousScrollValue = currentScroll;
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [headerHideThreshold, isHeaderVisible]);

  return isHeaderVisible;
}

export { useStickyHeader };
